import { useState, useRef } from 'preact/hooks';
import { SendIcon } from './icons';

export function MessageInput({
  disabled,
  onSend
}: {
  disabled?: boolean;
  onSend: (text: string) => void;
}) {
  const [value, setValue] = useState('');
  const ref = useRef<HTMLTextAreaElement>(null);

  const autoGrow = () => {
    const el = ref.current;
    if (!el) return;
    el.style.height = 'auto';
    el.style.height = `${Math.min(el.scrollHeight, 96)}px`;
  };

  const submit = () => {
    const trimmed = value.trim();
    if (!trimmed || disabled) return;
    onSend(trimmed);
    setValue('');
    if (ref.current) ref.current.style.height = 'auto';
    ref.current?.focus();
  };

  return (
    <div class="input-row">
      <div class="input-shell">
        <textarea
          ref={ref}
          value={value}
          disabled={disabled}
          onInput={(e) => {
            setValue((e.target as HTMLTextAreaElement).value);
            autoGrow();
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && !e.shiftKey) {
              e.preventDefault();
              submit();
            }
          }}
          placeholder="Write a message…"
          rows={1}
          aria-label="Message"
        />
        <button
          class="send-btn"
          onClick={submit}
          disabled={disabled || !value.trim()}
          aria-label="Send message"
        >
          <SendIcon />
        </button>
      </div>
    </div>
  );
}
